const insertSpaceAfterPunctuation = (text) =>
  text.replace(/\s*([,.!?:;]+)(?!\s*$)\s*/g, '$1 ');

export default insertSpaceAfterPunctuation;
